import { lazy, Suspense, useContext } from 'react';
import type { IDemoMeta } from '../../utils/parse';
import { LanguageContext } from '../../utils';

import './index.less';

const PC = lazy(() => import('./PC'));
const Mobile = lazy(() => import('./Mobile'));

export interface IDemoProps {
  demo: IDemoMeta;
  fullPath: string;
  style?: React.CSSProperties;
  [foo: string]: any;
}

export function DemoView(props: {
  siteType: string;
  demoType?: string;
  navigator: React.ReactNode;
  navigatorMobile: React.ReactNode;
  copyWritings: any;
  useLoader?: () => any;
  isPlayground?: boolean;
  initialTheme?: string;
}) {
  const {
    siteType,
    demoType,
    navigator,
    navigatorMobile,
    copyWritings,
    useLoader,
    isPlayground,
    initialTheme,
  } = props;
  const { isMobile } = useContext(LanguageContext);
  return (
    <Suspense>
      {isMobile ? (
        <Mobile
          siteType={siteType}
          demoType={demoType}
          navigator={navigatorMobile}
          copyWritings={copyWritings}
          useLoader={useLoader}
          isPlayground={isPlayground}
          initialTheme={initialTheme}
        />
      ) : (
        <PC
          siteType={siteType}
          demoType={demoType}
          navigator={navigator}
          copyWritings={copyWritings}
          useLoader={useLoader}
          isPlayground={isPlayground}
          initialTheme={initialTheme}
        />
      )}
    </Suspense>
  );
}
